import React__default, { useRef } from 'react';
import { D as DropdownPopper } from '../../Dropdown/DropdownPopper-BfH25QSV.js';
import { u as usePopperSelectListHelper } from '../../Dropdown/usePopperSelectListHelper-BQY_M0qK.js';
import { S as SelectList } from '../../SelectList/SelectList-SGDw-BtH.js';

const SplitButtonPopper = ({
  isOpen,
  onClose,
  $minWidth,
  trigger,
  offsetDistance,
  offsetSkidding,
  children,
  focusedAnchorEl,
  onPopoverClose
}) => {
  const popperRef = useRef(null);
  const {
    focusedValue,
    handleKeyDown,
    onPopoverElementDidMount
  } = usePopperSelectListHelper({
    isOpen,
    anchorEl: focusedAnchorEl,
    popperRef,
    onClose,
    focusSelected: true
  });
  return /*#__PURE__*/React__default.createElement(DropdownPopper, {
    isOpen: isOpen,
    onClose: onPopoverClose,
    onKeyDown: handleKeyDown,
    popperRef: popperRef,
    $minWidth: $minWidth,
    trigger: trigger,
    offsetDistance: offsetDistance,
    offsetSkidding: offsetSkidding,
    popperElementDidMount: onPopoverElementDidMount,
    closePopperIfTriggerClicked: true
  }, /*#__PURE__*/React__default.createElement(SelectList, {
    afterOnSelect: onClose,
    focusedValue: focusedValue
  }, children));
};

export { SplitButtonPopper as S };
//# sourceMappingURL=SplitButtonPopper-P8RzUks3.js.map
